"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransactionInfo = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _definitions = require("@ppay/definitions");
var _decimal = _interopRequireDefault(require("decimal.js"));
var _ui = require("../../../../../ui");
var _hooks = require("../../../../../../hooks");
var _TotalAmount = require("./TotalAmount");
var _AmountItem = require("./AmountItem");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var info = function info(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.99992 14.1667C3.31792 14.1667 0.333252 11.182 0.333252 7.5C0.333252 3.818 3.31792 0.833328 6.99992 0.833328C10.6819 0.833328 13.6666 3.818 13.6666 7.5C13.6666 11.182 10.6819 14.1667 6.99992 14.1667ZM6.99992 12.8333C8.41441 12.8333 9.77096 12.2714 10.7712 11.2712C11.7713 10.271 12.3333 8.91448 12.3333 7.5C12.3333 6.08551 11.7713 4.72895 10.7712 3.72876C9.77096 2.72856 8.41441 2.16666 6.99992 2.16666C5.58543 2.16666 4.22888 2.72856 3.22868 3.72876C2.22849 4.72895 1.66659 6.08551 1.66659 7.5C1.66659 8.91448 2.22849 10.271 3.22868 11.2712C4.22888 12.2714 5.58543 12.8333 6.99992 12.8333ZM6.33325 9.5H7.66659V10.8333H6.33325V9.5ZM6.33325 4.16666H7.66659V8.16666H6.33325V4.16666Z",
    fill: "#545462"
  }));
};
info.defaultProps = {
  width: "14",
  height: "15",
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var StyledTotalAmount = (0, _styledComponents.default)(_TotalAmount.TotalAmount)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 20px 0;\n"])));
var Tooltip = (0, _styledComponents.default)(_ui.Tooltip)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  .tooltip-inner {\n    width: 260px !important;\n  }\n"])));
var ServiceFeeTitle = function ServiceFeeTitle(_ref) {
  var fiatTicker = _ref.fiatTicker,
    fee = _ref.fee;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var ref = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "d-flex",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_ui.Svg, {
    className: "me-1",
    as: info
  })), t('serviceFee'), /*#__PURE__*/_react.default.createElement(Tooltip, {
    placement: "bottom",
    target: ref
  }, t('replenishServiceFeeFiatTooltip', {
    fiatTicker: fiatTicker,
    fee: new _decimal.default(fee).mul(100)
  })));
};
var TransactionInfo = function TransactionInfo() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation2.t;
  var _useReplenishContext = (0, _hooks.useReplenishContext)(),
    fiat = _useReplenishContext.fiat;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AmountItem.AmountItem, {
    title: t('amount'),
    ticker: _definitions.Ticker.USD,
    fiatTicker: fiat.ticker,
    amount: fiat.value,
    fiatTickerAmount: fiat.convertedValue
  }), /*#__PURE__*/_react.default.createElement(_AmountItem.AmountItem, {
    title: /*#__PURE__*/_react.default.createElement(ServiceFeeTitle, {
      fiatTicker: fiat.ticker,
      fee: fiat.fee
    }),
    ticker: _definitions.Ticker.USD,
    fiatTicker: fiat.ticker,
    amount: fiat.feeValue,
    fiatTickerAmount: fiat.convertedFeeValue,
    className: "mb-0"
  }), /*#__PURE__*/_react.default.createElement(StyledTotalAmount, {
    ticker: fiat.ticker,
    amount: fiat.totalValue,
    convertedTicker: _definitions.Ticker.USD,
    convertedAmount: fiat.convertedTotalValue
  }), /*#__PURE__*/_react.default.createElement(_ui.Button, {
    color: "secondary",
    loading: false,
    disabled: fiat.disabled,
    onClick: function onClick() {},
    wide: true
  }, t('pay')));
};
exports.TransactionInfo = TransactionInfo;